import {
  UpdateBookkeepersManagementTaskStatusDocument,
  UpdateBookkeepersManagementTaskStatusMutation,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'

export default function useUpdateTaskStatus() {
  const [updateTaskStatusCall, { data, loading }] = useMutation(
    UpdateBookkeepersManagementTaskStatusDocument,
    {
      extractorFn: (taskData: UpdateBookkeepersManagementTaskStatusMutation) =>
        taskData.bookkeepersManagementMutations.updateBookkeepersmanagementTaskTaskStatus,
    }
  )

  const updateTaskStatus = async (id: string, completed: boolean) => {
    const unhandledResult = await updateTaskStatusCall({
      context: { isBookkeeperView: true },
      variables: {
        completed,
        id,
      },
    })

    const result = handleResult(unhandledResult, () => undefined)

    if (!result.success) {
      return {
        error: true,
      } as const
    }

    return {
      data: result.data.taskStatus,
      error: false,
    } as const
  }

  const taskStatus =
    data?.bookkeepersManagementMutations.updateBookkeepersmanagementTaskTaskStatus.taskStatus

  return {
    updateTaskStatus,
    taskStatus,
    loading,
  }
}
